import { Helmet } from "react-helmet-async";

// The canonical origin for marketing pages. Every build points here, including
// dev builds, so a copy of the site served from anywhere else never competes
// with the real one in search results.
const SITE_ORIGIN = "https://breadhq.com";

// The title, description and link-preview tags for one marketing page.
//
// These matter mostly in the prerendered HTML (see scripts/prerender.mjs):
// search engines and link-preview scrapers read the served HTML and never run
// the app, so the prerender copies these tags into each page's static file. In
// the browser they also keep the tab title in step with the page.
export function PageMeta(props: {
  title: string;
  description: string;
  // The page's path, starting with "/".
  path: string;
}): JSX.Element {
  const url = `${SITE_ORIGIN}${props.path === "/" ? "" : props.path}`;

  return (
    <Helmet>
      <title>{props.title}</title>
      <meta name="description" content={props.description} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Bread" />
      <meta property="og:title" content={props.title} />
      <meta property="og:description" content={props.description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:card" content="summary" />
    </Helmet>
  );
}
